var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rich-text grid grid__base", class: _vm.rootClasses },
    [
      _vm.isNested
        ? _c(
            "div",
            { staticClass: "rich-text--content" },
            [
              _c("div", { domProps: { innerHTML: _vm._s(_vm.body) } }),
              _vm._v(" "),
              _vm.links.length
                ? _c("link-list", { attrs: { links: _vm.links } })
                : _vm._e()
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "grid--container" },
            [
              _c("div", { staticClass: "grid--row" }, [
                _c("div", {
                  staticClass: "rich-text--col grid--col",
                  domProps: { innerHTML: _vm._s(_vm.body) }
                })
              ]),
              _vm._v(" "),
              _vm.links.length
                ? _c("link-list", { attrs: { links: _vm.links } })
                : _vm._e()
            ],
            1
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-555fa3d4", { render: render, staticRenderFns: staticRenderFns })
  }
}